// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/img/icons/right_swap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/img/icons/left_swap.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@media (max-width: 1024px) {
  .canvas_buttons_bottom {
    max-height: 57px !important;
  }
  .type_interface_checkbox-wall_item-img {
    width: 41dvw !important;
  }
  .type_interface_colors-buttons_label {
    width: 100%;
  }
  .pcr-app {
    position: absolute !important;
    left: 0 !important;
    top: 50% !important;
  }
  #blade-range_wrap,
  #louvers-range_wrap {
    width: 204px;
  }
  .type_interface_colors-buttons .colors_container {
    grid-template-columns: repeat(2, auto) !important;
    justify-content: right;
    align-items: center;
    gap: 18px !important;
  }
  body {
    overflow: hidden;
    overflow-x: hidden;
  }
  .type_interface_colors-buttons_item {
    width: 54px;
  }
  .container_shareAR {
    left: 60%;
    width: 100%;
    height: 30px;
    transform: translateX(-20%);
    display: flex;
    align-items: center;
    z-index: 10000;
    top: 2.5dvh;
  }
  #js-toggleDayNight .switch {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
  }
  #js-toggleDayNight .switch input {
    display: none !important;
  }
  .type_interface_colors-buttons_label {
    position: relative;
  }
  .summary__button {
    font-size: 14px;
    width: 100% !important;
    margin-top: 20px !important;
    position: relative !important;
    margin-bottom: 35px !important;
  }
  .main-content {
    position: relative;
    display: block !important;
  }
  #ar_model_viewer {
    height: 50vh;
    position: fixed;
    top: 0;
    z-index: 9999;
  }
  .interface-container {
    position: relative;
    padding-top: 50vh;
    width: 100%;
    max-width: 100%;
    padding: 50vh 16px 0 16px;
    height: 100% !important;
  }
  .input_time_switch {
    width: fit-content;
    left: auto;
    z-index: 10000;
    top: 2dvh;
  }
  #switchButton-time {
    width: 26px !important;
    height: 15px !important;
  }
  .canvas_buttons {
    justify-content: normal;
    right: 16px;
    display: flex;
    flex-direction: row-reverse;
  }
  .portal-container {
    transform: none !important;
    width: 100%;
    border: 0;
    box-shadow: 0px 0px 20px 0px rgba(217, 222, 218, 0.6);
    left: 0 !important;
    right: 0;
    top: 50vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: 50vh;
    position: absolute !important;
    box-sizing: border-box;
    z-index: 10000;
  }
  .icon_wrap {
    display: flex;
    align-items: center;
    height: fit-content;
  }
  .icon_container {
    display: flex !important;
    flex-direction: row-reverse;
    bottom: 0;
    top: auto;
    overflow: auto;
    grid-template-columns: repeat(11, 1fr);
    column-gap: 16px;
    transform: translateX(-50%);
    left: 50%;
    width: calc(100% - 32px);
    scroll-behavior: smooth;
    margin-bottom: 16px;
  }
  .icon_container::-webkit-scrollbar {
    display: none;
    /* Для Chrome, Safari, Opera */
  }
  .icon_container {
    -ms-overflow-style: none;
    /* Для Internet Explorer */
    scrollbar-width: none;
    /* Для Firefox */
  }
  .left_button {
    position: absolute;
    display: flex;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 16px;
    height: 16px;
    left: 16px;
    transform: translateY(-100%);
    margin-bottom: 32px;
  }
  .right_button {
    display: flex;
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 16px;
    height: 16px;
    right: 16px;
    transform: translateY(-100%);
    margin-bottom: 32px;
  }
  .portal-light {
    position: absolute;
    width: 100vw;
    right: 0;
    bottom: 70px;
    top: auto !important;
    border-radius: 12px 12px 0 0;
    height: 128px;
  }
  .portal-light__remove {
    position: absolute;
    top: 1px;
    right: 45%;
    color: transparent;
  }
  .portal-heaters {
    height: 128px;
    position: absolute;
    width: 100vw;
    right: 0;
    bottom: 70px;
    top: auto !important;
    border-radius: 12px 12px 0 0;
  }
  .portal-heaters__remove {
    position: absolute;
    top: 1px;
    right: 65%;
    color: transparent;
  }
  .portal-screen {
    overflow: hidden;
    position: absolute;
    width: 100vw;
    height: 230px;
    right: 0;
    bottom: 70px;
    top: auto !important;
    border-radius: 12px 12px 0 0;
  }
  .portal-screen__remove {
    position: absolute;
    top: 1px;
    right: 65%;
    color: transparent;
  }
  .portal-screen__block__title {
    position: relative;
    color: #629A33;
    margin-bottom: 22px;
  }
  .portal-screen__block__title::after {
    position: absolute;
    content: "";
    width: 100%;
    background-color: rgba(98, 154, 51, 0.5);
    height: 1px;
    display: flex;
    bottom: -6px;
  }
  .portal-screen__block-color {
    position: absolute;
    top: 100px;
    z-index: 0;
  }
  .portal-screen__block-color .portal-screen__block-color__title {
    cursor: pointer;
    color: #629A33;
    line-height: 22px;
    position: absolute;
    left: 160px;
    top: -43.5px;
    z-index: 111;
  }
  .portal-screen__block__list {
    grid-template-columns: repeat(6, 1fr);
    row-gap: 8px;
    z-index: 1;
    position: relative;
  }
  .portal-screen__block__list__item {
    width: 30px;
  }
  .portal-screen__block__list__item__container {
    width: 30px;
    height: 30px;
    overflow: hidden;
  }
  .portal-screen__block__list__item__container img {
    width: 100%;
    height: 100%;
  }
  .portal-screen__block-color__list {
    grid-template-columns: repeat(6, 1fr);
  }
  .portal-screen__block-color__list__item {
    width: 30px;
  }
  .portal-screen__block-color__list__item__container {
    width: 30px;
    height: 30px;
    overflow: hidden;
  }
  .portal-screen__block-color__list__item__container img {
    width: 100%;
    height: 100%;
  }
  .full-screen {
    visibility: hidden;
  }
  .portal-shades {
    position: absolute;
    width: 100vw;
    right: 0;
    bottom: 70px;
    top: auto !important;
    border-radius: 12px 12px 0 0;
  }
  .portal-shades__remove {
    position: absolute;
    top: 1px;
    right: 65%;
    color: transparent;
  }
  .interface-container-portal::after {
    content: "";
    background-color: rgba(98, 154, 51, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .visible {
    visibility: visible;
    opacity: 1;
    z-index: 99999;
  }
  .hide {
    visibility: hidden;
    opacity: 0;
  }
  .active {
    text-underline-offset: 11px;
    color: #3A3A3C !important;
    text-decoration-color: #629A33;
  }
  #summary-content {
    top: 0;
    z-index: 9999;
    padding: 0;
    border-radius: 0;
  }
  #zip-screen-portal {
    overflow: scroll;
    height: 30vh;
  }
  .sum__page #js-summary-image-preview-1 {
    width: 100%;
  }
  .sum__page {
    padding: 16px;
    border-radius: 0;
    border: none;
  }
  .sum__page__title {
    margin-bottom: 20px;
    text-align: center;
  }
  .sum__page__close {
    visibility: hidden;
  }
  .sum__page__main-list {
    width: 100%;
  }
  .sum__page__buttons {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
  }
  .sum__page__buttons__button {
    display: block;
    width: 100%;
    margin: 8px 0;
  }
  .form-container {
    width: 100% !important;
    height: 100%;
    padding: 16px !important;
    border-radius: 0;
    overflow: scroll;
  }
  #closeForm {
    visibility: hidden;
  }
  .form__top {
    display: block !important;
    margin-bottom: 24px !important;
  }
  .form__top > :not(:last-child) {
    margin-bottom: 24px;
  }
  .form__group label {
    font-size: 10px !important;
    line-height: 12px !important;
  }
  .form__header__title {
    font-size: 14px !important;
  }
  .form__input {
    height: 47px;
    font-size: 12px !important;
  }
  .form__header__title {
    font-size: 14px !important;
  }
  .form__check label {
    font-size: 12px !important;
  }
  .form__check #agree-error {
    font-size: 10px !important;
    transform: translateY(calc(-100% - 10px));
  }
  .form__check-input {
    width: 25px !important;
    margin-top: 4px;
  }
  .form__buttons {
    display: block !important;
  }
  .form__buttons #cancelButton {
    margin-bottom: 26px;
  }
  .form__buttons button {
    width: 100%;
    display: block;
  }
  #js-showModalShare {
    text-decoration: none;
    font-size: 12px !important;
    margin-right: 16px !important;
  }
  #js-showModalShare::before {
    width: 14px !important;
    height: 14px !important;
  }
  #js-showModalShare:visited {
    color: #3A3A3C;
  }
  #js-showModalShare #menu-icon-share {
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px !important;
  }
  #js-showModalQRcode #menu-icon-ar {
    width: 16px !important;
    height: 16px !important;
    margin-right: 5px !important;
    margin-bottom: -2px;
  }
  #js-resetConfig #menu-icon-reset {
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px !important;
    margin-bottom: -2px;
  }
  #js-showModalQRcode {
    text-decoration: none;
    font-size: 12px !important;
  }
  #js-showModalQRcode::before {
    width: 14px !important;
    height: 14px !important;
  }
  #js-showModalQRcode:visited {
    color: #3A3A3C;
  }
  #js-resetConfig {
    text-decoration: none;
    font-size: 12px !important;
    margin-right: 16px !important;
  }
  #js-resetConfig::before {
    width: 14px !important;
    height: 14px !important;
  }
  #js-resetConfig:visited {
    color: #3A3A3C;
  }
  #menu-icon-ar-text,
  #menu-icon-share-text,
  #menu-icon-reset-text {
    display: none;
  }
  #share {
    position: absolute;
    z-index: 9999;
    left: 0;
    right: 0;
    margin: 0 20px;
    width: auto;
  }
  .type_interface_post-size_item {
    height: 36px !important;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .type_interface_post-size_item input {
    position: absolute;
  }
  .sun__icon::after {
    content: "";
  }
  .interface__group .interface__group__head__name {
    font-size: 12px !important;
  }
  .interface__group .interface__group__head__param {
    font-size: 12px !important;
  }
  .type_interface_radio-model {
    justify-content: space-evenly !important;
    gap: 7px !important;
  }
  .type_interface_radio-model_item {
    font-size: 12px !important;
    width: 44dvw !important;
    height: 110px !important;
  }
  .type_interface_radio-model_option {
    padding: 2px !important;
    width: 41dvw !important;
    height: 90% !important;
    -webkit-appearance: none;
    appearance: none;
    border-radius: 0;
  }
  .type_interface_radio-model_label {
    font-size: 12px !important;
  }
  .type_interface_checkbox-wall_item {
    font-size: 12px !important;
  }
  .type_interface_checkbox-wall_option {
    width: 16px;
    height: 16px;
  }
  .type_interface_louvre-type {
    gap: 14px;
  }
  .type_interface_louvre-type_item {
    width: 42dvw !important;
    font-size: 11px !important;
  }
  .type_interface_electronic_item {
    font-size: 12px !important;
    width: 41dvw;
  }
  .type_interface_colors-buttons .colors_container .add-info {
    font-size: 12px !important;
  }
  .range__wrapper {
    width: 88dvw !important;
  }
  .range__wrapper_dimensions {
    width: 57dvw !important;
  }
  .range {
    gap: 7dvw;
  }
  .roof-name {
    font-size: 12px !important;
  }
  .color-name {
    font-size: 12px !important;
  }
  .type_interface_electronic .electronic-name::before {
    width: 15px;
    height: 15px;
  }
  .electronic-name {
    align-items: center;
  }
  .interface__group__inputs {
    padding: 22px 6px 33px 0px;
  }
  .type_interface_electronic {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 6px;
    justify-items: center;
  }
  .type_interface_electronic .image-container {
    height: fit-content;
    width: 100%;
  }
  #js-toggleDayNight {
    left: 16px;
  }
  .form__check-input:checked::before {
    left: 3.4px !important;
  }
  .sum__page__main-list {
    gap: 28px;
  }
  .share-ar__container {
    top: 75% !important;
  }
  .sum__page__buttons {
    gap: 0px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/mobileStyles.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EAQE;IACE,2BAAA;EAPF;EAUA;IACE,uBAAA;EARF;EAWA;IACE,WAAA;EATF;EAYA;IACE,6BAAA;IACA,kBAAA;IACA,mBAAA;EAVF;EAaA;;IAEE,YAAA;EAXF;EAcA;IACE,iDAAA;IACA,sBAAA;IACA,mBAAA;IACA,oBAAA;EAZF;EAeA;IACE,gBAAA;IACA,kBAAA;EAbF;EAgBA;IACE,WAAA;EAdF;EAiBA;IACE,SAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;IACA,aAAA;IACA,mBAAA;IACA,cAAA;IACA,WAAA;EAfF;EA4BA;IACE,wBAAA;IACA,8BAAA;IACA,kCAAA;IACA,6BAAA;IACA,sBAAA;EA1BF;EA6BA;IACE,wBAAA;EA3BF;EA8BA;IACE,kBAAA;EA5BF;EA+BA;IACE,eAAA;IACA,sBAAA;IACA,2BAAA;IACA,6BAAA;IACA,8BAAA;EA7BF;EAgCA;IACE,kBAAA;IACA,yBAAA;EA9BF;EAiCA;IACE,YAAA;IACA,eAAA;IACA,MAAA;IACA,aAAA;EA/BF;EAkCA;IACE,kBAAA;IACA,iBAAA;IACA,WAAA;IACA,eAAA;IACA,yBAAA;IACA,uBAAA;EAhCF;EAmCA;IACE,kBAAA;IACA,UAAA;IACA,cAAA;IACA,SAAA;EAjCF;EAoCA;IACE,sBAAA;IACA,uBAAA;EAlCF;EAqCA;IACE,uBAAA;IACA,WAAA;IACA,aAAA;IACA,2BAAA;EAnCF;EAsCA;IACE,0BAAA;IACA,WAAA;IACA,SAAA;IACA,qDAAA;IACA,kBAAA;IACA,QAAA;IACA,oBAAA;IACA,gBAAA;IACA,iCAAA;IACA,YAAA;IACA,6BAAA;IACA,sBAAA;IACA,cAAA;EApCF;EAuCA;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EArCF;EAwCA;IACE,wBAAA;IACA,2BAAA;IACA,SAAA;IACA,SAAA;IACA,cAAA;IACA,sCAAA;IACA,gBAAA;IACA,2BAAA;IACA,SAAA;IACA,wBAAA;IACA,uBAAA;IACA,mBAAA;EAtCF;EAyCA;IACE,aAAA;IACA,8BAAA;EAvCF;EA0CA;IACE,wBAAA;IACA,0BAAA;IACA,qBAAA;IACA,gBAAA;EAxCF;EA2CA;IACE,kBAAA;IACA,aAAA;IACA,yDAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,4BAAA;IACA,mBAAA;EAzCF;EA4CA;IACE,aAAA;IACA,kBAAA;IACA,yDAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,4BAAA;IACA,mBAAA;EA1CF;EA6CA;IACE,kBAAA;IACA,YAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;IACA,4BAAA;IACA,aAAA;EA3CF;EA6CE;IACE,kBAAA;IACA,QAAA;IACA,UAAA;IACA,kBAAA;EA3CJ;EA6DA;IACE,aAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;IACA,4BAAA;EA3DF;EA6DE;IACE,kBAAA;IACA,QAAA;IACA,UAAA;IACA,kBAAA;EA3DJ;EA6EA;IACE,gBAAA;IACA,kBAAA;IACA,YAAA;IACA,aAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;IACA,4BAAA;EA3EF;EA6EE;IACE,kBAAA;IACA,QAAA;IACA,UAAA;IACA,kBAAA;EA3EJ;EA4FE;IACE,kBAAA;IACA,cC/SS;ID2TT,mBAAA;EArGJ;EA2FI;IACE,kBAAA;IACA,WAAA;IACA,WAAA;IACA,wCAAA;IACA,WAAA;IACA,aAAA;IACA,YAAA;EAzFN;EA+FE;IACE,kBAAA;IACA,UAAA;IACA,UAAA;EA7FJ;EA+FI;IACE,eAAA;IACA,cCrUO;IDsUP,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EA7FN;EAiGE;IACE,qCAAA;IACA,YAAA;IACA,UAAA;IACA,kBAAA;EA/FJ;EAiGI;IACE,WAAA;EA/FN;EAiGM;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EA/FR;EAkGQ;IACE,WAAA;IACA,YAAA;EAhGV;EAuGI;IACE,qCAAA;EArGN;EAuGM;IACE,WAAA;EArGR;EAuGQ;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EArGV;EAwGU;IACE,WAAA;IACA,YAAA;EAtGZ;EA8GA;IACE,kBAAA;EA5GF;EA+GA;IACE,kBAAA;IACA,YAAA;IACA,QAAA;IACA,YAAA;IACA,oBAAA;IACA,4BAAA;EA7GF;EA+GE;IACE,kBAAA;IACA,QAAA;IACA,UAAA;IACA,kBAAA;EA7GJ;EAgIE;IACE,WAAA;IACA,wCAAA;IACA,eAAA;IAEA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EA/HJ;EAmIA;IACE,mBAAA;IACA,UAAA;IAEA,cAAA;EAlIF;EAqIA;IACE,kBAAA;IACA,UAAA;EAnIF;EAsIA;IACE,2BAAA;IACA,yBAAA;IACA,8BC1bW;EDsTb;EAuIA;IACE,MAAA;IACA,aAAA;IACA,UAAA;IACA,gBAAA;EArIF;EAwIA;IACE,gBAAA;IACA,YAAA;EAtIF;EAyIA;IACE,WAAA;EAvIF;EA0IA;IACE,aAAA;IACA,gBAAA;IACA,YAAA;EAxIF;EA0IE;IACE,mBAAA;IACA,kBAAA;EAxIJ;EA2IE;IACE,kBAAA;EAzIJ;EA4IE;IACE,WAAA;EA1IJ;EA6IE;IACE,WAAA;IACA,aAAA;IACA,8BAAA;EA3IJ;EA6II;IACE,cAAA;IACA,WAAA;IACA,aAAA;EA3IN;EAgJA;IACE,sBAAA;IACA,YAAA;IACA,wBAAA;IACA,gBAAA;IACA,gBAAA;EA9IF;EAiJA;IACE,kBAAA;EA/IF;EAkJA;IACE,yBAAA;IAMA,8BAAA;EArJF;EAiJE;IACE,mBAAA;EA/IJ;EAsJE;IACE,0BAAA;IACA,4BAAA;EApJJ;EAwJA;IACE,0BAAA;EAtJF;EAyJA;IACE,YAAA;IACA,0BAAA;EAvJF;EA0JA;IACE,0BAAA;EAxJF;EA4JE;IACE,0BAAA;EA1JJ;EA6JE;IACE,0BAAA;IACA,yCAAA;EA3JJ;EA+JA;IACE,sBAAA;IACA,eAAA;EA7JF;EAgKA;IACE,yBAAA;EA9JF;EAgKE;IACE,mBAAA;EA9JJ;EAiKE;IACE,WAAA;IACA,cAAA;EA/JJ;EAmKA;IACE,qBAAA;IACA,0BAAA;IACA,6BAAA;EAjKF;EAmKE;IACE,sBAAA;IACA,uBAAA;EAjKJ;EAoKE;IACE,cC1jBe;EDwZnB;EAsKA;IACE,sBAAA;IACA,uBAAA;IACA,4BAAA;EApKF;EAuKA;IACE,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,mBAAA;EArKF;EAwKA;IACE,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,mBAAA;EAtKF;EAyKA;IACE,qBAAA;IACA,0BAAA;EAvKF;EAyKE;IACE,sBAAA;IACA,uBAAA;EAvKJ;EA0KE;IACE,cC5lBe;EDobnB;EA4KA;IACE,qBAAA;IACA,0BAAA;IACA,6BAAA;EA1KF;EA4KE;IACE,sBAAA;IACA,uBAAA;EA1KJ;EA6KE;IACE,cC3mBe;EDgcnB;EA+KA;;;IAGE,aAAA;EA7KF;EAgLA;IACE,kBAAA;IACA,aAAA;IACA,OAAA;IACA,QAAA;IACA,cAAA;IACA,WAAA;EA9KF;EAiLA;IACE,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,UAAA;EA/KF;EAiLE;IACE,kBAAA;EA/KJ;EAoLE;IACE,WAAA;EAlLJ;EAyLE;IACE,0BAAA;EAvLJ;EA0LE;IACE,0BAAA;EAxLJ;EA4LA;IACE,wCAAA;IACA,mBAAA;EA1LF;EA6LA;IACE,0BAAA;IACA,uBAAA;IACA,wBAAA;EA3LF;EA8LA;IACE,uBAAA;IACA,uBAAA;IACA,sBAAA;IACA,wBAAA;IACA,gBAAA;IACA,gBAAA;EA5LF;EA+LA;IACE,0BAAA;EA7LF;EAgMA;IACE,0BAAA;EA9LF;EAiMA;IACE,WAAA;IACA,YAAA;EA/LF;EAkMA;IACE,SAAA;EAhMF;EAmMA;IACE,uBAAA;IACA,0BAAA;EAjMF;EAoMA;IACE,0BAAA;IACA,YAAA;EAlMF;EAqMA;IACE,0BAAA;EAnMF;EAsMA;IACE,uBAAA;EApMF;EAuMA;IACE,uBAAA;EArMF;EAwMA;IACE,SAAA;EAtMF;EAyMA;IACE,0BAAA;EAvMF;EA0MA;IACE,0BAAA;EAxMF;EA2MA;IACE,WAAA;IACA,YAAA;EAzMF;EA4MA;IACE,mBAAA;EA1MF;EA6MA;IACE,0BAAA;EA3MF;EA8MA;IACE,gDAAA;IACA,QAAA;IACA,qBAAA;EA5MF;EA+MA;IACE,mBAAA;IACA,WAAA;EA7MF;EAgNA;IACE,UAAA;EA9MF;EAiNA;IACE,sBAAA;EA/MF;EAkNA;IACE,SAAA;EAhNF;EAmNA;IACE,mBAAA;EAjNF;EAoNA;IACE,mBAAA;EAlNF;AACF","sourcesContent":["@use \"../styles/variables\" as vars;\n\n@media (max-width: 1024px) {\n  // @supports (height: 100dvh) {\n  //   html,\n  //   body {\n  //     height: 100dvh;\n  //   }\n  // }\n\n  .canvas_buttons_bottom {\n    max-height: 57px !important;\n  }\n\n  .type_interface_checkbox-wall_item-img {\n    width: 41dvw !important;\n  }\n\n  .type_interface_colors-buttons_label {\n    width: 100%;\n  }\n\n  .pcr-app {\n    position: absolute !important;\n    left: 0 !important;\n    top: 50% !important;\n  }\n\n  #blade-range_wrap,\n  #louvers-range_wrap {\n    width: 204px;\n  }\n\n  .type_interface_colors-buttons .colors_container {\n    grid-template-columns: repeat(2, auto) !important;\n    justify-content: right;\n    align-items: center;\n    gap: 18px !important;\n  }\n\n  body {\n    overflow: hidden;\n    overflow-x: hidden;\n  }\n\n  .type_interface_colors-buttons_item {\n    width: 54px;\n  }\n\n  .container_shareAR {\n    left: 60%;\n    width: 100%;\n    height: 30px;\n    transform: translateX(-20%);\n    display: flex;\n    align-items: center;\n    z-index: 10000;\n    top: 2.5dvh;\n  }\n\n  // .container_shareAR {\n  //   position: absolute !important;\n  //   right: 50%;\n  //   transform: translateX(50%);\n  // }\n\n  // .body-hidden {\n  //   overflow: hidden !important;\n  // }\n\n  #js-toggleDayNight .switch {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    text-align: center !important;\n    width: 100% !important;\n  }\n\n  #js-toggleDayNight .switch input {\n    display: none !important;\n  }\n\n  .type_interface_colors-buttons_label {\n    position: relative;\n  }\n\n  .summary__button {\n    font-size: 14px;\n    width: 100% !important;\n    margin-top: 20px !important;\n    position: relative !important;\n    margin-bottom: 35px !important;\n  }\n\n  .main-content {\n    position: relative;\n    display: block !important;\n  }\n\n  #ar_model_viewer {\n    height: 50vh;\n    position: fixed;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .interface-container {\n    position: relative;\n    padding-top: 50vh;\n    width: 100%;\n    max-width: 100%;\n    padding: 50vh 16px 0 16px;\n    height: 100% !important;\n  }\n\n  .input_time_switch {\n    width: fit-content;\n    left: auto;\n    z-index: 10000;\n    top: 2dvh;\n  }\n\n  #switchButton-time {\n    width: 26px !important;\n    height: 15px !important;\n  }\n\n  .canvas_buttons {\n    justify-content: normal;\n    right: 16px;\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .portal-container {\n    transform: none !important;\n    width: 100%;\n    border: 0;\n    box-shadow: 0px 0px 20px 0px #d9deda99;\n    left: 0 !important;\n    right: 0;\n    top: 50vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    height: 50vh;\n    position: absolute !important;\n    box-sizing: border-box;\n    z-index: 10000;\n  }\n\n  .icon_wrap {\n    display: flex;\n    align-items: center;\n    height: fit-content;\n  }\n\n  .icon_container {\n    display: flex !important;\n    flex-direction: row-reverse;\n    bottom: 0;\n    top: auto;\n    overflow: auto;\n    grid-template-columns: repeat(11, 1fr);\n    column-gap: 16px;\n    transform: translateX(-50%);\n    left: 50%;\n    width: calc(100% - 32px);\n    scroll-behavior: smooth;\n    margin-bottom: 16px;\n  }\n\n  .icon_container::-webkit-scrollbar {\n    display: none;\n    /* Для Chrome, Safari, Opera */\n  }\n\n  .icon_container {\n    -ms-overflow-style: none;\n    /* Для Internet Explorer */\n    scrollbar-width: none;\n    /* Для Firefox */\n  }\n\n  .left_button {\n    position: absolute;\n    display: flex;\n    background-image: url(../../public/img/icons/right_swap.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 16px;\n    height: 16px;\n    left: 16px;\n    transform: translateY(-100%);\n    margin-bottom: 32px;\n  }\n\n  .right_button {\n    display: flex;\n    position: absolute;\n    background-image: url(../../public/img/icons/left_swap.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 16px;\n    height: 16px;\n    right: 16px;\n    transform: translateY(-100%);\n    margin-bottom: 32px;\n  }\n\n  .portal-light {\n    position: absolute;\n    width: 100vw;\n    right: 0;\n    bottom: 70px;\n    top: auto !important;\n    border-radius: 12px 12px 0 0;\n    height: 128px;\n\n    &__remove {\n      position: absolute;\n      top: 1px;\n      right: 45%;\n      color: transparent;\n\n      // &::after {\n      //   content: \"\";\n      //   background-image: url(../../public/img/icons/bin.svg);\n      //   background-position: center;\n      //   background-size: cover;\n      //   display: flex;\n      //   width: 16px;\n      //   height: 16px;\n      //   padding: 5px;\n      //   box-sizing: border-box;\n      //   margin: 5px;\n      //   transform: translateY(-35%);\n      // }\n    }\n  }\n\n  .portal-heaters {\n    height: 128px;\n    position: absolute;\n    width: 100vw;\n    right: 0;\n    bottom: 70px;\n    top: auto !important;\n    border-radius: 12px 12px 0 0;\n\n    &__remove {\n      position: absolute;\n      top: 1px;\n      right: 65%;\n      color: transparent;\n\n      // &::after {\n      //   content: \"\";\n      //   background-image: url(../../public/img/icons/bin.svg);\n      //   background-position: center;\n      //   background-size: cover;\n      //   display: flex;\n      //   width: 16px;\n      //   height: 16px;\n      //   padding: 5px;\n      //   box-sizing: border-box;\n      //   margin: 5px;\n      //   transform: translateY(-35%);\n      // }\n    }\n  }\n\n  .portal-screen {\n    overflow: hidden;\n    position: absolute;\n    width: 100vw;\n    height: 230px;\n    right: 0;\n    bottom: 70px;\n    top: auto !important;\n    border-radius: 12px 12px 0 0;\n\n    &__remove {\n      position: absolute;\n      top: 1px;\n      right: 65%;\n      color: transparent;\n\n      // &::after {\n      //   content: \"\";\n      //   background-image: url(../../public/img/icons/bin.svg);\n      //   background-position: center;\n      //   background-size: cover;\n      //   display: flex;\n      //   width: 16px;\n      //   height: 16px;\n      //   padding: 5px;\n      //   box-sizing: border-box;\n      //   margin: 5px;\n      //   transform: translateY(-35%);\n      // }\n    }\n\n    &__block__title {\n      position: relative;\n      color: vars.$second-color;\n\n      &::after {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        background-color: rgba($color: vars.$second-color, $alpha: 0.5);\n        height: 1px;\n        display: flex;\n        bottom: -6px;\n      }\n\n      margin-bottom: 22px;\n    }\n\n    &__block-color {\n      position: absolute;\n      top: 100px;\n      z-index: 0;\n\n      .portal-screen__block-color__title {\n        cursor: pointer;\n        color: vars.$second-color;\n        line-height: 22px;\n        position: absolute;\n        left: 160px;\n        top: -43.5px;\n        z-index: 111;\n      }\n    }\n\n    &__block__list {\n      grid-template-columns: repeat(6, 1fr);\n      row-gap: 8px;\n      z-index: 1;\n      position: relative;\n\n      &__item {\n        width: 30px;\n\n        &__container {\n          width: 30px;\n          height: 30px;\n          overflow: hidden;\n\n\n          img {\n            width: 100%;\n            height: 100%;\n          }\n        }\n      }\n    }\n\n    &__block-color {\n      &__list {\n        grid-template-columns: repeat(6, 1fr);\n\n        &__item {\n          width: 30px;\n\n          &__container {\n            width: 30px;\n            height: 30px;\n            overflow: hidden;\n\n\n            img {\n              width: 100%;\n              height: 100%;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .full-screen {\n    visibility: hidden;\n  }\n\n  .portal-shades {\n    position: absolute;\n    width: 100vw;\n    right: 0;\n    bottom: 70px;\n    top: auto !important;\n    border-radius: 12px 12px 0 0;\n\n    &__remove {\n      position: absolute;\n      top: 1px;\n      right: 65%;\n      color: transparent;\n\n      // &::after {\n      //   content: \"\";\n      //   background-image: url(../../public/img/icons/bin.svg);\n      //   background-position: center;\n      //   background-size: cover;\n      //   display: flex;\n      //   width: 16px;\n      //   height: 16px;\n      //   padding: 5px;\n      //   box-sizing: border-box;\n      //   margin: 5px;\n      //   transform: translateY(-35%);\n      // }\n    }\n  }\n\n  .interface-container-portal {\n    &::after {\n      content: \"\";\n      background-color: rgba($color: vars.$second-color, $alpha: 0.5);\n      position: fixed;\n      //   pointer-events: none;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n  }\n\n  .visible {\n    visibility: visible;\n    opacity: 1;\n    // position: relative;\n    z-index: 99999;\n  }\n\n  .hide {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  .active {\n    text-underline-offset: 11px;\n    color: vars.$black-color-second !important;\n    text-decoration-color: vars.$second-color;\n  }\n\n  #summary-content {\n    top: 0;\n    z-index: 9999;\n    padding: 0;\n    border-radius: 0;\n  }\n\n  #zip-screen-portal {\n    overflow: scroll;\n    height: 30vh;\n  }\n\n  .sum__page #js-summary-image-preview-1 {\n    width: 100%;\n  }\n\n  .sum__page {\n    padding: 16px;\n    border-radius: 0;\n    border: none;\n\n    &__title {\n      margin-bottom: 20px;\n      text-align: center;\n    }\n\n    &__close {\n      visibility: hidden;\n    }\n\n    &__main-list {\n      width: 100%;\n    }\n\n    &__buttons {\n      width: 100%;\n      display: flex;\n      flex-direction: column-reverse;\n\n      &__button {\n        display: block;\n        width: 100%;\n        margin: 8px 0;\n      }\n    }\n  }\n\n  .form-container {\n    width: 100% !important;\n    height: 100%;\n    padding: 16px !important;\n    border-radius: 0;\n    overflow: scroll;\n  }\n\n  #closeForm {\n    visibility: hidden;\n  }\n\n  .form__top {\n    display: block !important;\n\n    &> :not(:last-child) {\n      margin-bottom: 24px;\n    }\n\n    margin-bottom: 24px !important;\n  }\n\n  .form__group {\n    label {\n      font-size: 10px !important;\n      line-height: 12px !important;\n    }\n  }\n\n  .form__header__title {\n    font-size: 14px !important;\n  }\n\n  .form__input {\n    height: 47px;\n    font-size: 12px !important;\n  }\n\n  .form__header__title {\n    font-size: 14px !important;\n  }\n\n  .form__check {\n    label {\n      font-size: 12px !important;\n    }\n\n    #agree-error {\n      font-size: 10px !important;\n      transform: translateY(calc(-100% - 10px));\n    }\n  }\n\n  .form__check-input {\n    width: 25px !important;\n    margin-top: 4px;\n  }\n\n  .form__buttons {\n    display: block !important;\n\n    #cancelButton {\n      margin-bottom: 26px;\n    }\n\n    button {\n      width: 100%;\n      display: block;\n    }\n  }\n\n  #js-showModalShare {\n    text-decoration: none;\n    font-size: 12px !important;\n    margin-right: 16px !important;\n\n    &::before {\n      width: 14px !important;\n      height: 14px !important;\n    }\n\n    &:visited {\n      color: vars.$black-color-second;\n    }\n  }\n\n  #js-showModalShare #menu-icon-share {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 4px !important;\n  }\n\n  #js-showModalQRcode #menu-icon-ar {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 5px !important;\n    margin-bottom: -2px;\n  }\n\n  #js-resetConfig #menu-icon-reset {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 4px !important;\n    margin-bottom: -2px;\n  }\n\n  #js-showModalQRcode {\n    text-decoration: none;\n    font-size: 12px !important;\n\n    &::before {\n      width: 14px !important;\n      height: 14px !important;\n    }\n\n    &:visited {\n      color: vars.$black-color-second;\n    }\n  }\n\n  #js-resetConfig {\n    text-decoration: none;\n    font-size: 12px !important;\n    margin-right: 16px !important;\n\n    &::before {\n      width: 14px !important;\n      height: 14px !important;\n    }\n\n    &:visited {\n      color: vars.$black-color-second;\n    }\n  }\n\n  #menu-icon-ar-text,\n  #menu-icon-share-text,\n  #menu-icon-reset-text {\n    display: none;\n  }\n\n  #share {\n    position: absolute;\n    z-index: 9999;\n    left: 0;\n    right: 0;\n    margin: 0 20px;\n    width: auto;\n  }\n\n  .type_interface_post-size_item {\n    height: 36px !important;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    input {\n      position: absolute;\n    }\n  }\n\n  .sun__icon {\n    &::after {\n      content: \"\";\n    }\n\n    &:hover {}\n  }\n\n  .interface__group {\n    .interface__group__head__name {\n      font-size: 12px !important;\n    }\n\n    .interface__group__head__param {\n      font-size: 12px !important;\n    }\n  }\n\n  .type_interface_radio-model {\n    justify-content: space-evenly !important;\n    gap: 7px !important;\n  }\n\n  .type_interface_radio-model_item {\n    font-size: 12px !important;\n    width: 44dvw !important;\n    height: 110px !important;\n  }\n\n  .type_interface_radio-model_option {\n    padding: 2px !important;\n    width: 41dvw !important;\n    height: 90% !important;\n    -webkit-appearance: none;\n    appearance: none;\n    border-radius: 0;\n  }\n\n  .type_interface_radio-model_label {\n    font-size: 12px !important;\n  }\n\n  .type_interface_checkbox-wall_item {\n    font-size: 12px !important;\n  }\n\n  .type_interface_checkbox-wall_option {\n    width: 16px;\n    height: 16px;\n  }\n\n  .type_interface_louvre-type {\n    gap: 14px;\n  }\n\n  .type_interface_louvre-type_item {\n    width: 42dvw !important;\n    font-size: 11px !important;\n  }\n\n  .type_interface_electronic_item {\n    font-size: 12px !important;\n    width: 41dvw;\n  }\n\n  .type_interface_colors-buttons .colors_container .add-info {\n    font-size: 12px !important;\n  }\n\n  .range__wrapper {\n    width: 88dvw !important;\n  }\n\n  .range__wrapper_dimensions {\n    width: 57dvw !important;\n  }\n\n  .range {\n    gap: 7dvw;\n  }\n\n  .roof-name {\n    font-size: 12px !important;\n  }\n\n  .color-name {\n    font-size: 12px !important;\n  }\n\n  .type_interface_electronic .electronic-name::before {\n    width: 15px;\n    height: 15px;\n  }\n\n  .electronic-name {\n    align-items: center;\n  }\n\n  .interface__group__inputs {\n    padding: 22px 6px 33px 0px;\n  }\n\n  .type_interface_electronic {\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 6px;\n    justify-items: center;\n  }\n\n  .type_interface_electronic .image-container {\n    height: fit-content;\n    width: 100%;\n  }\n\n  #js-toggleDayNight {\n    left: 16px;\n  }\n\n  .form__check-input:checked::before {\n    left: 3.4px !important;\n  }\n\n  .sum__page__main-list {\n    gap: 28px;\n  }\n\n  .share-ar__container {\n    top: 75% !important;\n  }\n\n  .sum__page__buttons {\n    gap: 0px !important;\n  }\n}","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
